import { useEffect, useState } from "react";
import clsx from "clsx";
import checkCircle from "./assets/checkCircle.svg";
import errorCircle from "./assets/errorCircle.svg";

const PikkoToast = ({ type = "success", message = "", duration = 3000, onClose }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const enterTimer = setTimeout(() => setVisible(true), 10); 
    return () => clearTimeout(enterTimer);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), duration);
    return () => clearTimeout(timer);
  }, [duration]);

  useEffect(() => {
    if (!visible) {
      const timer = setTimeout(() => {
        if (onClose) onClose();
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [visible, onClose]);

  return (
    <div
      className={clsx(
        "fixed left-1/2 bottom-8 z-[9999] w-[90vw] md:w-[400px] -translate-x-1/2 transform transition-all duration-500",
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-40"
      )}
    >
      <div
        className={clsx(
          "flex items-center gap-3 rounded-full px-5 py-3 shadow-lg border backdrop-blur-sm",
          "bg-white border-gray-100",
          type === "success" && "border-green-200",
          type === "error" && "border-red-400"
        )}
      >
        <img
          src={type === "success" ? checkCircle : errorCircle}
          alt={type}
          className="h-10 w-10"
        />
        <div className="flex flex-col">
          <span
            className={clsx(
              "geomanistMedium text-2xl",
              type === "success" ? "text-zinc-800" : "text-red-700"
            )}
          >
            {type === "success" ? "Succès" : "Erreur"}
          </span>
          <span className="text-xl geomanistRegular text-gray-700">{message}</span>
        </div>
      </div>
    </div>
  );
};

export default PikkoToast;
